import { fbButton, tw, pinterest, whatsapp, linkedin, email, telegram, ok, vk } from "vanilla-sharing";

function init() {
    const shareButtons = document.querySelectorAll(".sharePage__button");

    shareButtons.forEach((button) => {
        button.addEventListener("click", () => onSelect(button));
        button.addEventListener("keydown", (e) => {
            if (e.key === "Enter") {
                onSelect(button);
            }
        });
    });
}

function onSelect(button) {
    const icon = button.getAttribute("data-icon");
    const title = getMetaData("og:title");
    const image = getMetaData("og:image:secure_url");
    const description = getMetaData("og:description");
    const url = window.location.href;

    switch (icon) {
        case "facebook": {
            fbButton({ url, title });
            break;
        }
        case "twitter": {
            tw({ url, title });
            break;
        }
        case "pinterest": {
            pinterest({ url, description, media: image });
            break;
        }
        case "whatsapp": {
            whatsapp({ url, title, phone: "" });
            break;
        }
        case "linkedin-in": {
            linkedin({ url, title, description });
            break;
        }
        case "email": {
            email({
                to: "",
                url,
                title,
                description,
                subject: "",
            });
            break;
        }
        case "telegram": {
            telegram({ url, title });
            break;
        }
        case "okRu": {
            ok({ url, title, image });
            break;
        }
        case "vk": {
            vk({ 
                url,
                title,
                description,
                image,
                isVkParse: true,
             });
            break;
        }
        default:
    }
}

function getMetaData(property) {
    const metaData = document.querySelector("meta[property='" + property + "']");
    const metaDataValue = metaData ? metaData.content : "";
    return metaDataValue;
}

export default { init };
